export default {"src":"/_next/static/media/heart.3f686b02.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};